import React, { Component } from 'react';
import { map } from 'lodash';
import cIf from 'classnames';

export type FooterProps = {
    classNames?: string,
};

export class Footer extends Component<FooterProps> {
    render() {
        return (
            <div className={cIf([this.props.classNames, "footer-menu"])}>
                {this.props.children}
            </div>
        );
    }
}

export type FooterColumnProps = {
    classNames?: string,
    fullWidth?: boolean, // Make a full span 12 column
    children: React.ReactNode
};
export function FooterColumn(props: FooterColumnProps) {
        return <div>
            {props.children}
        </div>;
}
FooterColumn.defaultProps = {
    fullWidth: false
};

export type FooterItemListProps = {
    children: React.ReactNode[],
    spaced?: boolean
};
export function FooterItemList(props: FooterItemListProps) {
    return (
        <ul className={cIf("item-list", { spaced: props.spaced })}>
            {map(props.children, (e, i) =>
                <li key={i}>{e}</li>
            )}
        </ul>
    );
}

export type FooterTitleProps = {
    children: string
};
export function FooterTitle(props: FooterTitleProps) {
    return <h4>{props.children}</h4>;
}

export type FooterSubTitleProps = {
    children: string
};
export function FooterSubTitle(props: FooterSubTitleProps) {
    return <h5>{props.children}</h5>;
}

export type FooterLabelProps = {
    children: string
};
export function FooterLabel(props: FooterLabelProps) {
    return <span className="footer-label">{props.children}</span>;
}

export type FooterNoteProps = {
    children: React.ReactNode
};
export function FooterNote(props) {
    return <span className="footer-note">{props.children}</span>;
}



